import { useState, useEffect } from 'react';

export default function StickyMobileCTA() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShow(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToCompare = () => {
    document.getElementById('comparar')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div
      className={`md:hidden fixed bottom-0 left-0 right-0 z-50 transition-transform duration-300 ${
        show ? 'translate-y-0' : 'translate-y-full'
      }`}
    >
      <div className="bg-white border-t border-gray-200 px-4 py-3 flex gap-3 items-center">
        <button
          onClick={scrollToCompare}
          className="flex-1 flex items-center justify-center gap-2 bg-green-600 hover:bg-green-500 text-white font-bold text-sm py-3.5 rounded-xl transition-all cursor-pointer active:scale-95"
        >
          <i className="ri-send-plane-fill" />
          Enviar dinero ahora
        </button>
        <a
          href="https://wise.com/invite/dic/arlindad30"
          target="_blank"
          rel="nofollow noopener noreferrer"
          className="flex-shrink-0 flex items-center justify-center gap-1.5 bg-emerald-100 text-emerald-700 font-bold text-xs py-3.5 px-4 rounded-xl cursor-pointer whitespace-nowrap"
        >
          Wise <i className="ri-arrow-right-line" />
        </a>
      </div>
    </div>
  );
}
